import React from 'react';
import styled, { css } from 'styled-components';
import { Tooltip, Button, IconButton } from '@mui/material';
import { FaCogs, FaMagic, FaMicrophone, FaMicrophoneSlash, FaVideo, FaVideoSlash } from 'react-icons/fa';
import { CameraIcon } from '../../components/icons/CameraIcon/CameraIcon';

interface ButtonsContainerProps {
  isWhitelabel: boolean;
  videoOff?: boolean;
  audioOff?: boolean;
  roomIsEmpty?: boolean;
  showJoinButton?: boolean;
  showConfigDevicesButton?: boolean;
  onVideoButtonClick?: () => void;
  onAudioButtonClick?: () => void;
  setShowEffectsModal?: (value: boolean) => void;
  setShowConfigDevicesModal?: (value: boolean) => void;
  onJoinButtonClick?: () => void;
  buttonRefJoin?: React.RefObject<HTMLButtonElement>;
}

export const ButtonsContainer: React.FC<ButtonsContainerProps> = ({
  isWhitelabel,
  videoOff,
  audioOff,
  roomIsEmpty,
  showJoinButton,
  showConfigDevicesButton,
  onVideoButtonClick,
  onAudioButtonClick,
  setShowEffectsModal,
  setShowConfigDevicesModal,
  onJoinButtonClick,
  buttonRefJoin
}) => (
  <Container isWhitelabel={isWhitelabel}>
    {showConfigDevicesButton === true && (
      <ControlButtonsWrapper>
        <Tooltip title={!videoOff ? 'Desabilitar câmera' : 'Habilitar câmera'} arrow>
          <ControlButton onClick={onVideoButtonClick}>
            {videoOff ? <FaVideoSlash size={22} /> : <FaVideo size={22} />}
          </ControlButton>
        </Tooltip>

        <Tooltip title={!audioOff ? 'Desabilitar áudio' : 'Habilitar áudio'} arrow>
          <ControlButton onClick={onAudioButtonClick}>
            {audioOff ? <FaMicrophoneSlash size={22} /> : <FaMicrophone size={22} />}
          </ControlButton>
        </Tooltip>

        <Tooltip title="Mudar plano de fundo da câmera" arrow>
          <ControlButton onClick={() => setShowEffectsModal?.(true)}>
            <FaMagic size={20} />
          </ControlButton>
        </Tooltip>

        <Tooltip title="Configurar dispositivos" arrow>
          <ControlButton onClick={() => setShowConfigDevicesModal?.(true)}>
            <FaCogs size={24} />
          </ControlButton>
        </Tooltip>
      </ControlButtonsWrapper>
    )}
    {isWhitelabel && showJoinButton !== false && (
      <JoinButton variant="contained" onClick={onJoinButtonClick} disabled={roomIsEmpty} ref={buttonRefJoin} >
        <div style={{ margin: "4px 4px 5px 4px" }}>
          <IconWrapper>
            {roomIsEmpty ? <Spinner /> : <CameraIcon />}
          </IconWrapper>
        </div>
        Entrar na sala
      </JoinButton>
    )}

  </Container>
);

const Container = styled.div<{ isWhitelabel?: boolean }>`
  align-items: center;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: space-between;

  @container (max-width: 768px) {
    justify-content: center;
  }
`;

const ControlButtonsWrapper = styled.div<{ isWhitelabel?: boolean }>`
  display: flex;
  gap: 16px;
`;

const ControlButton = styled(IconButton)`
  && {
    background-color: rgba(0, 0, 0, 0.7);
    border: 1px solid #f8f9fa;
    color: #f8f9fa;
    height: 48px;
    width: 48px;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.25);
    }
  }
`;

const JoinButton = styled(Button)`
  && {
    background: #00b19d;
    color: #fff;
    font-weight: 700;
    height: 40px;
    margin-top: 10%;

    &:hover {
      background-color: #8ceee3;
    }

    @container (max-width: 560px) {
      width: 100%;
      height: 40px;
    }
  }
`;

const IconWrapper = styled.div`
  margin: 12px 4px 5px 4px;
`;

const Spinner = styled.div`
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top: 6px solid #fff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
